import { DeviceNodePolyline } from '@features/components/LocationTracking/types';

const firstDepartureMs = (polylines: DeviceNodePolyline[]): number | null => {
  const match = polylines
    .map((polyline) => (polyline.departureTime ? new Date(polyline.departureTime).getTime() : null))
    .find((ms): ms is number => ms !== null && !Number.isNaN(ms));
  return match ?? null;
};

export const calculateRouteProgress = (
  polylines: DeviceNodePolyline[],
  arrivalIsoTime: string | null,
): number | null => {
  if (!arrivalIsoTime) return null;

  const departureMs = firstDepartureMs(polylines);
  if (departureMs === null) return null;

  const arrivalMs = new Date(arrivalIsoTime).getTime();
  if (Number.isNaN(arrivalMs)) return null;

  const totalMs = arrivalMs - departureMs;
  if (totalMs <= 0) return null;

  const elapsedMs = Math.max(0, Math.min(Date.now() - departureMs, totalMs));
  return elapsedMs / totalMs;
};
